import React from "react";

const TradeArrowDownIcon = ({ className, size = 20, color = "#FF2828", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M16.2751 9.55829C16.5193 9.80245 16.5193 10.1983 16.2751 10.4425L10.4418 16.2758C10.3201 16.3975 10.1601 16.4591 10.0001 16.4591C9.84006 16.4591 9.68004 16.3983 9.55837 16.2758L3.72504 10.4425C3.48087 10.1983 3.48087 9.80245 3.72504 9.55829C3.9692 9.31412 4.36507 9.31412 4.60923 9.55829L10.0009 14.9499L15.3925 9.55829C15.6359 9.31412 16.0309 9.31412 16.2751 9.55829ZM9.55837 10.4417C9.68004 10.5633 9.84006 10.625 10.0001 10.625C10.1601 10.625 10.3201 10.5642 10.4418 10.4417L16.2751 4.60834C16.5193 4.36417 16.5193 3.96831 16.2751 3.72414C16.0309 3.47997 15.6351 3.47997 15.3909 3.72414L9.99925 9.11578L4.6076 3.72414C4.36344 3.47997 3.96757 3.47997 3.72341 3.72414C3.47924 3.96831 3.47924 4.36417 3.72341 4.60834L9.55837 10.4417Z"
      fill={color}
    />
  </svg>
);

export default TradeArrowDownIcon;
